let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aRqGl")).then(() => parcelRequire('hX1AL'));